import { match as id } from "../../../src/params/id.ts";
import { match as integer } from "../../../src/params/integer.ts";
import { match as language } from "../../../src/params/language.ts";
import { match as notExistingLanguage } from "../../../src/params/notExistingLanguage.ts";
import { match as shopwareId } from "../../../src/params/shopwareId.ts";
import { match as slug } from "../../../src/params/slug.ts";
import { match as urlPart } from "../../../src/params/urlPart.ts";
import { match as uuidParam } from "../../../src/params/uuidParam.ts";

export const matchers = { id, integer, language, notExistingLanguage, shopwareId, slug, urlPart, uuidParam };